const gTrendsRoute = [
  {
    path: "/gtrends/exploration",
    name: "gTrendsIndex",
    component: () => import("@/views/gtrends/Index"),
    meta: {
      layout: "content",
      resource: "gtrends",
      action: "manage",
      //   rmrAnalytics: {
      //     track: true,
      //     eventType: "programmatique-dashboard",
      //     eventCategory: "page-view",
      //   },
    },
  },
  {
    path: "/gtrends/notifications",
    name: "gTrendsNotifications",
    component: () => import("@/views/gtrends/Notifications"),
    meta: {
      layout: "content",
      resource: "gtrends",
      action: "manage",
      //   rmrAnalytics: {
      //     track: true,
      //     eventType: "programmatique-dashboard",
      //     eventCategory: "page-view",
      //   },
    },
  },
];

export default gTrendsRoute;
